import { useEffect } from 'react'
import { getAllCategories, getAllSegments } from '../../../services/sBook/segment.service';

const useGetSegments = (segments, setSegments) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllSegments();
                const response = serviceResponse.data;
                const aux = [];
                
                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux.push({ key: element.id, text: element.name, title:  element.name})
                    });
                }

                setSegments(aux);
            }
            catch (error) {
                setSegments([]);
            }
        }
        
        if (segments === null) {
            getData()
        }
    }, [segments, setSegments]);
}

const useGetCategories = (categories, setCategories) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllCategories();
                const response = serviceResponse.data;
                const aux = [];
                
                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux.push({ key: element.id, text: element.name, title:  element.name})
                    });
                }

                setCategories(aux);
            }
            catch (error) {
                setCategories([]);
            }
        }
        
        if (categories === null) {
            getData()
        }
    }, [categories, setCategories]);
}

export {
    useGetSegments,
    useGetCategories
}